import React from 'react';
import styles from './index.module.css';

const CalendarIcon = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V96H208V208ZM48,80V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80Z' />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M231.88,175.08A56.26,56.26,0,0,1,176,224C96.6,224,32,159.4,32,80A56.26,56.26,0,0,1,80.92,24.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,117.39,96c-.18.27-.37.52-.57.77L96,121.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,231.88,175.08Z' />
  </svg>
);

const InfoIcon = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z' />
  </svg>
);

export const PRESET_ICONS = {
  calendar: <CalendarIcon />,
  phone: <PhoneIcon />,
  info: <InfoIcon />,
};

const VARIANT_CLASS = {
  neutral: '',
  primary: styles.primary,
};

const CallActionButton = ({
  icon,
  iconPreset,
  title,
  subtitle,
  onClick,
  variant = 'neutral',
  ariaLabel,
  disabled = false,
}) => {
  const resolvedIcon = icon || (iconPreset ? PRESET_ICONS[iconPreset] : null);
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.neutral;

  return (
    <button
      type='button'
      className={`${styles.button} ${variantClass}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || title}
    >
      {resolvedIcon && (
        <span className={styles.icon_bg} aria-hidden='true'>
          <span className={styles.icon}>{resolvedIcon}</span>
        </span>
      )}
      <span className={styles.text}>
        <span className={styles.title}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </span>
    </button>
  );
};

export default CallActionButton;
